import { motion } from "framer-motion";

interface ExpandableProps extends React.PropsWithChildren {
  expanded: boolean;
}

const Expandable: React.FC<ExpandableProps> = ({ expanded, children }) => (
  <motion.div
    key="expandable"
    initial={{ height: expanded ? "auto" : 0 }}
    animate={{ height: expanded ? "auto" : 0 }}
    transition={{ duration: expanded ? 0.3 : 0.2, type: "tween" }}
    style={{ overflow: "hidden" }}
  >
    {children}
  </motion.div>
);

export { Expandable };
